export default __webpack_public_path__ + "static/media/about-card-limits.53270c4a.svg";